import { Fragment } from "react";
import BootstrapModal from "react-bootstrap/Modal";
import useLang from "Shared/hooks/useLanguage";

const SHORTCUTS: [string, string][] = [
  ["/", "Focus quick find"],
  ["j", "Next row"],
  ["k", "Previous row"],
  ["Enter", "Open focused row"],
  ["x", "Select / unselect row"],
  ["Esc", "Close detail or search"],
  ["1 … 6", "Switch tab"],
  ["?", "Show this help"],
];

const ShortcutsModal = ({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) => {
  const { t } = useLang();
  return (
    <BootstrapModal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="vr2-cm-dialog"
      contentClassName="vr2-cm-content"
    >
      <BootstrapModal.Header
        closeButton
        className="d-flex align-items-center bg-light-primary py-4"
      >
        <h4 className="m-0">{t("Keyboard shortcuts")}</h4>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <div className="vr2-keys">
          {SHORTCUTS.map(([key, label]) => (
            <Fragment key={key}>
              <kbd>{key}</kbd>
              <span>{t(label)}</span>
            </Fragment>
          ))}
        </div>
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default ShortcutsModal;
